export default __webpack_public_path__ + "static/media/contacts_error.5b033b4a.jpg";